export class NameValuePair {
  constructor(
    public name: string,
    public value: any,
    public planName?: string
  ) {}
}

export class ToggleableNameValuePair extends NameValuePair {
  constructor(
    public name: string,
    public value: any,
    public planName?: string,
    public disabled: boolean = false,
    public authDisabled?: boolean,
    public selected?: boolean,
    public innerGroups?: ToggleableNameValuePair[]
  ) {
    super(name, value);
  }
}
